import React, { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import logoNew from "../../../assets/logo-new.png"; // adjust path if needed
import {useTheme} from "../../ThemeProvider/ThemeContext";

const MobileHeader = () => {
  const navigate = useNavigate();
  const { isDark, setIsDark } = useTheme()  ;



  const styles = useMemo(() => {
    if (isDark) {
      return {
        headerBg: "#0F1424",
        border: "1px solid #1E2642",
        iconBtnBg: "#12172A",
        iconBtnBorder: "1px solid #232B4A",
        iconColor: "#E8ECF8",
        tooltipBg: "rgba(15,20,36,0.95)",
        tooltipText: "#E8ECF8",
      };
    }
    return {
      headerBg: "#FFFFFF",
      border: "1px solid #E9ECEF",
      iconBtnBg: "#F8F9FA",
      iconBtnBorder: "1px solid #EEE",
      iconColor: "#0B1220",
      tooltipBg: "rgba(0,0,0,0.85)",
      tooltipText: "#FFFFFF",
    };
  }, [isDark]);
  return (
    <div
      className="w-100 border-bottom"
      style={{
        backgroundColor: styles.headerBg,
        borderBottom: styles.border,
      }}
    >
      <div
        className="d-flex align-items-center justify-content-between px-3"
        style={{ height: "56px" }}
      >
        {/* Logo */}
        <div className="d-flex align-items-center">
          <img
            src={logoNew}
            alt="EMAlpha"
            style={{ height: 28, width: "auto" }}
          />
        </div>

         <div className="d-flex align-items-center gap-2">
          {/* Theme Toggle */}
         
            <button
              className="btn d-flex align-items-center justify-content-center"
              style={{
                width: 40,
                height: 40,
                borderRadius: 14,
                background: styles.iconBtnBg,
                border: styles.iconBtnBorder,
                color: styles.iconColor,
              }}
              onClick={() => {
                setIsDark(!isDark);
                
                localStorage.setItem("theme", isDark ? "light" : "dark");
                window.dispatchEvent(new Event("emalpha:theme"));
              }}
              aria-label="Toggle theme"
              type="button"
            >
              <i className={isDark ? "fas fa-sun" : "fas fa-moon"} />
            </button>

          {/* Profile */}
          
            <button
              className="btn d-flex align-items-center justify-content-center"
              style={{
                width: 40,
                height: 40,
                borderRadius: 14,
                background: styles.iconBtnBg,
                border: styles.iconBtnBorder,
                color: styles.iconColor,
              }}
              onClick={() => navigate("/profile")}
              aria-label="Open profile"
              type="button"
            >
              <i className="fas fa-user" />
            </button>
        </div>
      </div>
    </div>
  );
};

export default MobileHeader;
